/**
 * Viewport entrance for CTA email signup copy + form.
 * Observes .cta-email-signup__content. Geometry-based threshold (tall blocks can reveal).
 */
(function () {
  var SEL = '.cta-email-signup--intro-reveal';

  function revealApi() {
    return window.R3NU && window.R3NU.reveal ? window.R3NU.reveal : null;
  }

  function shouldRevealGeometry(el, entry) {
    var api = revealApi();
    if (api) return api.shouldReveal(el, entry);
    return entry && entry.isIntersecting;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function detachListeners(root) {
    if (root._ctaEmailSignupIntroRevealIO) {
      root._ctaEmailSignupIntroRevealIO.disconnect();
      root._ctaEmailSignupIntroRevealIO = null;
    }
    if (root._ctaEmailSignupIntroRevealOnScroll) {
      window.removeEventListener('scroll', root._ctaEmailSignupIntroRevealOnScroll, { capture: true });
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', root._ctaEmailSignupIntroRevealOnScroll);
      }
      root._ctaEmailSignupIntroRevealOnScroll = null;
    }
    if (root._ctaEmailSignupIntroRevealOnResize) {
      window.removeEventListener('resize', root._ctaEmailSignupIntroRevealOnResize);
      root._ctaEmailSignupIntroRevealOnResize = null;
    }
  }

  function reveal(root) {
    root.classList.add('cta-email-signup--intro-revealed');
    detachListeners(root);
  }

  function teardown(root) {
    detachListeners(root);
  }

  function init(root) {
    if (!root || root.dataset.ctaEmailSignupIntroRevealInit) return;
    root.dataset.ctaEmailSignupIntroRevealInit = 'true';

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      reveal(root);
      return;
    }

    if (prefersReducedMotion()) {
      reveal(root);
      return;
    }

    if (root.classList.contains('cta-email-signup--intro-revealed')) return;

    var contentEl = root.querySelector('.cta-email-signup__content');
    if (!contentEl || contentEl.offsetHeight < 1) {
      reveal(root);
      return;
    }

    var api = revealApi();
    var rootMargin = api ? api.getRootMargin() : '0px 0px 12% 0px';
    var thresholdList = api ? api.buildThresholdList() : [0, 0.1, 0.2, 0.5, 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== contentEl) return;
          if (shouldRevealGeometry(contentEl, entry)) reveal(root);
        });
      },
      { threshold: thresholdList, rootMargin: rootMargin }
    );
    io.observe(contentEl);
    root._ctaEmailSignupIntroRevealIO = io;

    function onResize() {
      if (root.classList.contains('cta-email-signup--intro-revealed')) return;
      if (shouldRevealGeometry(contentEl, null)) reveal(root);
    }
    root._ctaEmailSignupIntroRevealOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    function onScrollRaf() {
      if (root.classList.contains('cta-email-signup--intro-revealed')) return;
      requestAnimationFrame(function () {
        if (root.classList.contains('cta-email-signup--intro-revealed')) return;
        try {
          if (root._ctaEmailSignupIntroRevealIO) {
            root._ctaEmailSignupIntroRevealIO.takeRecords().forEach(function (entry) {
              if (entry.target === contentEl && shouldRevealGeometry(contentEl, entry)) reveal(root);
            });
          }
        } catch (e) {}
        if (!root.classList.contains('cta-email-signup--intro-revealed') && shouldRevealGeometry(contentEl, null)) {
          reveal(root);
        }
      });
    }
    root._ctaEmailSignupIntroRevealOnScroll = onScrollRaf;
    window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScrollRaf, { passive: true });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('cta-email-signup--intro-revealed')) return;
        if (shouldRevealGeometry(contentEl, null)) reveal(root);
      });
    });
  }

  function destroy(root) {
    delete root.dataset.ctaEmailSignupIntroRevealInit;
    teardown(root);
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var el = t.matches && t.matches(SEL) ? t : t.querySelector(SEL);
    if (el) destroy(el);
  });

  function syncCtaEmailSignupInView() {
    document.querySelectorAll(SEL).forEach(function (root) {
      if (!root.dataset.ctaEmailSignupIntroRevealInit) return;
      if (root.classList.contains('cta-email-signup--intro-revealed')) return;
      var contentEl = root.querySelector('.cta-email-signup__content');
      var io = root._ctaEmailSignupIntroRevealIO;
      if (io && contentEl) {
        try {
          io.takeRecords().forEach(function (entry) {
            if (entry.target === contentEl && shouldRevealGeometry(contentEl, entry)) reveal(root);
          });
        } catch (e) {}
      }
      if (root.classList.contains('cta-email-signup--intro-revealed')) return;
      if (contentEl && shouldRevealGeometry(contentEl, null)) {
        reveal(root);
      }
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncCtaEmailSignupInView);
  }
})();
